import { useEffect } from 'react'
import { useRouter } from 'next/router'

export default function Redirector(destination) {
  return () => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const router = useRouter()

    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
      router.push(destination)
    }, [router, router?.isReady])
  }
}